import React, { useState } from "react";
import Styles from "./RFPPlaceBid.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useSelector } from "react-redux";

import TextInput from "../../../commons/Inputs/TextInput/TextInput";
import {
  createBid,
  updateBid,
} from "../../../Services/ReverseAuction/AlterApi";
import {
  formatDateTimeView,
  formatDateTimeViewRfq,
  formatDateType,
} from "../../../commons/FormatDate";
import Countdown from "../../../commons/CountDownTimer/Countdown";
import { ErrorMessage } from "../../../commons/Toast/ErrorMessage";
import ConfirmationModal from "../../../commons/ConfirmationModal/ConfirmationModal";
import Fileupload from "../../../commons/Inputs/FileUpload/Fileupload";
import { useLocation } from "react-router-dom";

const RFPPlaceBid = ({
  open,
  handleClose,
  tenderData,
  requisitionData,
  bidStage,
  handleUpdate,
  status,
}) => {
  const state = useSelector(
    (store) => store?.persistedReducer?.company?.stateLabel,
  );
  const location = useLocation();
  const url = location?.pathname || "";
  const isTradeConnect = url === "/tradeconnect";

  const bgCheck = state === "OD" && isTradeConnect;

  const role = useSelector(
    (state) => state?.persistedReducer?.user?.activeRole,
  ).toLowerCase();
  const userId = useSelector(
    (state) => state?.persistedReducer?.user?.user?.userId,
  );
  const parentEntityCompanyId = useSelector(
    (state) => state?.persistedReducer?.user?.parentEntityCompanyId,
  );

  const [bidPrice, setBidPrice] = useState(
    requisitionData?.selfBid?.bidPrice || "",
  );
  const [bidQuantity, setBidQuantity] = useState(
    requisitionData?.selfBid?.bidQuantityMw || "",
  );
  const [minimumQuantity, setMinimumQuantity] = useState(
    requisitionData?.selfBid?.minBidQuantityMw || "",
  );
  const [docId, setDocId] = useState(
    requisitionData?.selfBid?.documentId || null,
  );
  const [confirmModal, setConfirmModal] = useState({
    open: false,
    data: "",
    note: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const isUpdate = !!requisitionData?.selfBid;

  const handleBidPrice = (value) => {
    if (value < 0) {
      return ErrorMessage("Bid Price cannot be negative");
    }
    if (
      status?.includes("ra_ongoing") &&
      value > requisitionData?.selfBid?.bidPrice
    ) {
      return ErrorMessage(
        `Bid Price cannot be greater than ${requisitionData?.selfBid?.bidPrice}`,
      );
    }
    setBidPrice(value);
  };

  const handleBidQuantity = (value) => {
    if (value < 0) {
      return ErrorMessage("Bid Quantity cannot be negative");
    }
    setBidQuantity(value);
  };

  const handleMinimumQuantity = (value) => {
    if (value < 0) {
      return ErrorMessage("Minimum Quantity cannot be negative");
    }
    setMinimumQuantity(value);
  };

  const handleSubmit = async () => {
    if (isLoading) return;

    if (
      isTradeConnect &&
      Number(bidQuantity) > Number(requisitionData.selfBid?.bidQuantityMw)
    ) {
      return ErrorMessage(
        "Bid quantity should not be greater than previous bid quantity",
      );
    }

    if (
      Number(bidQuantity) > Number(requisitionData?.requiredQty) ||
      Number(bidQuantity) < Number(requisitionData?.minimumQty)
    ) {
      return ErrorMessage(
        "Bid quantity should be between minimum and required quantity",
      );
    }

    if (Number(bidQuantity) < Number(requisitionData?.minimumQty)) {
      return ErrorMessage(
        "Bid quantity should not be less than minimum quantity",
      );
    }

    if (
      Number(minimumQuantity) > Number(bidQuantity) ||
      Number(minimumQuantity) < Number(requisitionData?.minimumQty) ||
      Number(minimumQuantity) >= Number(requisitionData?.requiredQty)
    ) {
      return ErrorMessage(
        `Minimum quantity should be greater than ${requisitionData?.minimumQty}, less than ${requisitionData?.requiredQty}, and not more than bid quantity`,
      );
    }

    if (bgCheck && !docId) {
      return ErrorMessage("Please upload the Bank Guarantee document.");
    }

    try {
      setIsLoading(true);
      const tenderId = tenderData?.data?.id || tenderData?.id;
      let res;

      if (isUpdate) {
        res = await updateBid({
          id: requisitionData.selfBid.id,
          tenderId,
          bidPrice,
          bidQuantityMw: bidQuantity,
          minBidQuantityMw: minimumQuantity,
          requisitionId: requisitionData?.id,
          documentId: docId,
          created_by: userId,
        });
      } else {
        res = await createBid({
          tenderId,
          requisitionId: requisitionData?.id,
          initiator: role,
          bidStage,
          bidPrice,
          bidQuantityMw: bidQuantity,
          minBidQuantityMw: minimumQuantity,
          documentId: docId,
          created_by: userId,
        });
      }

      if (res?.data?.code === 200) {
        handleUpdate();
        handleClose();
      }
    } catch (error) {
      console.error("Error submitting bid:", error);
    } finally {
      setIsLoading(false);
      setConfirmModal({ open: false, data: "", note: "" });
    }
  };

  return (
    <>
      {confirmModal.open && (
        <ConfirmationModal
          open={confirmModal.open}
          handleClose={() =>
            setConfirmModal({ open: false, data: "", note: "" })
          }
          data={confirmModal.data}
          note={confirmModal.note}
          handleSubmit={handleSubmit}
        />
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="place-bid-modal"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          {/* Header */}
          <div
            className={`display_flex_row modalHeading ${Styles.headingText}`}
          >
            <div className={`headingText ${Styles.finalHead}`}>
              {isUpdate ? "Update" : "Place"} Bid(s)
            </div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>

          <div className={Styles.containerMainElem}>
            {/* Bidding Duration + Countdown */}
            <div className={Styles.detailsMainElements}>
              <div className="display_flex_row">
                <div
                  className={`display_flex_column_gap_8 ${Styles.reqMainElem}`}
                >
                  <div>
                    {status?.includes("ra_ongoing") ? "Auction" : "Bidding"}{" "}
                    Duration
                  </div>
                  <div className={Styles.tenderDateTime}>
                    <div className={Styles.tenderDate}>
                      <span>
                        {
                          formatDateTimeViewRfq(
                            tenderData?.bidStartDateTime,
                          )?.split("-")?.[0]
                        }
                      </span>
                      <span>
                        {
                          formatDateTimeViewRfq(
                            tenderData?.bidStartDateTime,
                          )?.split("-")?.[1]
                        }
                      </span>
                    </div>
                    <div>to</div>
                    <div className={Styles.tenderDate}>
                      <span>
                        {
                          formatDateTimeViewRfq(
                            tenderData?.bidCloseDateTime,
                          )?.split("-")?.[0]
                        }
                      </span>
                      <span>
                        {
                          formatDateTimeViewRfq(
                            tenderData?.bidCloseDateTime,
                          )?.split("-")?.[1]
                        }
                      </span>
                    </div>
                  </div>
                  {/* <div>
                    {formatDateTimeView(
                      status?.includes("ra_ongoing")
                        ? tenderData?.auctionStartDateTime
                        : tenderData?.bidStartDateTime,
                    )}{" "}
                    to{" "}
                    {formatDateTimeView(
                      status?.includes("ra_ongoing")
                        ? tenderData?.auctionCloseDateTime
                        : tenderData?.bidCloseDateTime,
                    )}
                  </div> */}
                </div>
                <Countdown status={status} tenderData={tenderData} type="bid" />
              </div>

              {/* Requisition Details */}
              <div className={`display_flex_row ${Styles.reqMainContainer}`}>
                <div
                  className={`display_flex_column_gap_8 ${Styles.reqMainElem}`}
                >
                  <div>Start and End Date</div>
                  <div>
                    {formatDateType(requisitionData?.dateStartAt)} to{" "}
                    {formatDateType(requisitionData?.dateEndAt)}
                  </div>
                </div>
                <div
                  className={`display_flex_column_gap_8 ${Styles.reqMainElem}`}
                >
                  <div>Start and End Time</div>
                  <div>
                    {requisitionData?.slotStartAt} -{" "}
                    {requisitionData?.slotEndAt === "23:59"
                      ? "24:00"
                      : requisitionData?.slotEndAt}
                  </div>
                </div>
                <div
                  className={`display_flex_column_gap_8 ${Styles.reqMainElem}`}
                >
                  <div>Req Qty (MW)</div>
                  <div>{requisitionData?.requiredQty} (MW)</div>
                </div>
                <div
                  className={`display_flex_column_gap_8 ${Styles.reqMainElem}`}
                >
                  <div>Min Qty (MW)</div>
                  <div>{requisitionData?.minimumQty} (MW)</div>
                </div>
                <div
                  className={`display_flex_column_gap_8 ${Styles.reqMainElem}`}
                >
                  <div>Self Bid Qty (MW)</div>
                  <div className={Styles.active_text}>
                    {requisitionData?.selfBid?.bidQuantityMw ?? "-"}
                  </div>
                </div>
                <div
                  className={`display_flex_column_gap_8 ${Styles.reqMainElem}`}
                >
                  <div>Self Bid Price (₹/kWh)</div>
                  <div className={Styles.active_text}>
                    {requisitionData?.selfBid?.bidPrice ?? "-"}
                  </div>
                </div>
              </div>
            </div>

            {/* Input Fields */}
            <div className={`display_flex_row ${Styles.inputMainCont}`}>
              <div>
                <TextInput
                  allowDecimal={true}
                  heading="Bid Quantity (MW)*"
                  value={bidQuantity}
                  onChange={handleBidQuantity}
                  example="Eg. 20.32"
                  type="number"
                />
              </div>
              <div>
                <TextInput
                  allowDecimal={true}
                  heading="Seller Min. Quantity (MW)*"
                  value={minimumQuantity}
                  onChange={handleMinimumQuantity}
                  example="Eg. 20.00"
                  type="number"
                />
              </div>
              <div>
                <TextInput
                  allowDecimal={true}
                  heading="Bid Price (₹/kWh)*"
                  value={bidPrice}
                  onChange={handleBidPrice}
                  example="Eg. 10"
                  type="number"
                />
              </div>
              <div>
                <Fileupload
                  accept=".pdf"
                  id="general-terms-conditions"
                  value={docId}
                  onChange={(val) => setDocId(val?.id)}
                  height="35"
                  heading={`BG Document${bgCheck ? "*" : ""}`}
                  example="Upload BG (.pdf)"
                  fileType="pdf"
                  isInPlaceBid={true}
                  viewMode={false}
                  previewTitle="Bank Guarantee Document Preview"
                  documentType="BANK_GUARANTEE"
                  parentEntityCompanyId={parentEntityCompanyId}
                />
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className={`display_flex_row_gap_8 ${Styles.buttonContianer}`}>
            <div className="activeButton_type_3" onClick={handleClose}>
              Cancel
            </div>
            <div
              className="activeButton"
              onClick={() =>
                setConfirmModal({
                  open: true,
                  data: `Do you want to ${isUpdate ? "Update" : "Place"} the Bid?`,
                  note: isUpdate
                    ? `Current Bid: ${bidQuantity}MW/₹${bidPrice}/kWh,\n Previous Bid: ${requisitionData.selfBid?.bidQuantityMw}MW/₹${requisitionData.selfBid?.bidPrice}/kWh`
                    : "EMD Amount will be blocked as per Terms and Conditions, if applicable.",
                })
              }
            >
              {isLoading ? "Loading..." : isUpdate ? "Update" : "Submit"}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RFPPlaceBid;
